import { Box, Center, HStack, Text } from "@chakra-ui/react";
import { GatsbyImage, getImage as getGatsbyImage } from "gatsby-plugin-image";
import React from "react";

import { graphql, useStaticQuery } from "gatsby";
import ResponsiveContainer from "./ResponsiveContainer";

const getImage = (node: any) => {
  if (!node) {
    return;
  }

  return getGatsbyImage(node);
};

const AwardCert = () => {
  const data = useStaticQuery(AwardCertQuery);

  const listLeader = [
    {
      image: getImage(data.cert_fips)!,
      alt: "cert fips",
    },
    {
      image: getImage(data.cert_taa)!,
      alt: "cert taa",
    },
    {
      image: getImage(data.cisco)!,
      alt: "cisco",
    },
  ];

  return (
    <ResponsiveContainer>
      <Box textAlign={"center"} mt={7} mb={3} mx={"auto"}>
        <Text textStyle={"h3"}>
          First organisation to be awarded FIPS 140-3 Validation Certificate
          #4795
        </Text>
      </Box>
      <Center py={2} mx={4}>
        <HStack mb={5}>
          {listLeader.map((item, index) => (
            <GatsbyImage
              key={index}
              image={item.image}
              alt={item.alt}
              loading="lazy"
              imgStyle={{ objectFit: "contain" }}
            />
          ))}
        </HStack>
      </Center>
    </ResponsiveContainer>
  );
};

export default AwardCert;

export const ImageData = graphql`
  fragment ImageData on File {
    childImageSharp {
      gatsbyImageData(layout: FIXED, placeholder: BLURRED)
    }
  }
`;

const AwardCertQuery = graphql`
  query {
    cert_fips: file(relativePath: { eq: "cert_fips_140_3.jpg" }) {
      ...ImageData
      childImageSharp {
        fixed(width: 223, height: 160) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    cert_taa: file(relativePath: { eq: "cert_taa.jpg" }) {
      ...ImageData
      childImageSharp {
        fixed(width: 129, height: 160) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    cisco: file(relativePath: { eq: "cisco.jpg" }) {
      ...ImageData
      childImageSharp {
        fixed(width: 213, height: 160) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`;
